import React, { useEffect, useState } from 'react';
import { Shield, CreditCard, Lock, Zap, Star } from 'lucide-react';
import { trackPixelEvent } from './useMetaPixel';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'elite'>('elite');
  const CHECKOUT_URLS = {
    pro: 'https://profelisto.com.ar/checkouts/cn/hWNDzsZEM145tXrhrqUiS4t0/es-ar?_r=AQABGBLrYVhXQsf9f44mOaq5HRXNndn49BAn3I8128vt9DY',
    elite: 'https://profelisto.com.ar/checkouts/cn/hWNDzsZQHofMEwc7SUvDOQ0g/es-ar?_r=AQAB_Z4BPNWHxF1WuUi37r-soq42GTnfM1ac1eyCgXzk98k'
  };
  const goToCheckout = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: selectedPlan === 'elite' ? 'Megapack Élite' : 'Pack Profesional',
      value: selectedPlan === 'elite' ? 27990 : 18990,
      currency: 'ARS'
    });
    window.location.href = CHECKOUT_URLS[selectedPlan];
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-20 bg-slate-100" data-id="element-170">
      <div className="max-w-2xl mx-auto px-4" data-id="element-171">
        {/* Countdown banner */}
        <div className="bg-slate-900 rounded-2xl p-6 mb-8 text-center text-white" data-id="element-172">
          <h2 className="text-lg md:text-xl font-extrabold mb-4 text-yellow-400" data-id="element-173">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>
          <div className="flex justify-center gap-3 mb-4" data-id="element-174">
            <div className="bg-slate-800 rounded-lg p-3 min-w-[64px]" data-id="element-175">
              <span className="text-2xl font-bold font-mono" data-id="element-176">
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span className="block text-[10px] text-slate-400 mt-1" data-id="element-177">HS</span>
            </div>
            <div className="text-2xl font-bold py-3" data-id="element-178">:</div>
            <div className="bg-slate-800 rounded-lg p-3 min-w-[64px]" data-id="element-179">
              <span className="text-2xl font-bold font-mono" data-id="element-180">
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span className="block text-[10px] text-slate-400 mt-1" data-id="element-181">MIN</span>
            </div>
            <div className="text-2xl font-bold py-3" data-id="element-182">:</div>
            <div className="bg-slate-800 rounded-lg p-3 min-w-[64px]" data-id="element-183">
              <span className="text-2xl font-bold font-mono text-red-400" data-id="element-184">
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
              <span className="block text-[10px] text-slate-400 mt-1" data-id="element-185">SEG</span>
            </div>
          </div>
          <p className="text-red-400 text-sm font-medium flex items-center justify-center gap-2" data-id="element-186">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-187"></span>
            El precio sube cuando termina el contador
          </p>
        </div>

        {/* Checkout card */}
        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8" data-id="element-188">
          <div className="text-center mb-8" data-id="element-189">
            <h3 className="text-3xl font-extrabold text-gray-900 mb-2" data-id="element-190">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500" data-id="element-191">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Profesional option */}
          <button type="button" onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-2xl border-2 p-5 mb-5 flex items-center gap-4 transition-all ${selectedPlan === 'pro' ? 'border-blue-500 bg-blue-50/40' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-192">
            <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'pro' ? 'border-blue-500' : 'border-gray-300'}`} data-id="element-193">
              {selectedPlan === 'pro' && <span className="w-3 h-3 rounded-full bg-blue-500" data-id="element-194"></span>}
            </span>
            <div className="flex-1" data-id="element-195">
              <div className="flex items-center gap-2" data-id="element-196">
                <span className="text-2xl" data-id="element-197">📘</span>
                <span className="font-extrabold text-gray-900 leading-tight" data-id="element-198">
                  PACK PROFESIONAL
                </span>
              </div>
              <p className="text-sm text-gray-500 mt-1" data-id="element-199">12 Tomos + 6 Bonus</p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-200">
              <span className="block text-sm text-gray-400 line-through" data-id="element-201">
                $29.990
              </span>
              <span className="text-2xl font-extrabold text-gray-900" data-id="element-202">
                $18.990
              </span>
            </div>
          </button>

          {/* Megapack Élite option */}
          <button type="button" onClick={() => setSelectedPlan('elite')} className={`w-full text-left rounded-2xl border-2 p-5 mb-6 flex items-start gap-4 transition-all ${selectedPlan === 'elite' ? 'border-yellow-500 bg-yellow-50/50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-203">
            <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center mt-1 ${selectedPlan === 'elite' ? 'border-yellow-500' : 'border-gray-300'}`} data-id="element-204">
              {selectedPlan === 'elite' && <span className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-205"></span>}
            </span>
            <div className="flex-1" data-id="element-206">
              <div className="flex items-center gap-2 mb-2" data-id="element-207">
                <span className="text-2xl" data-id="element-208">🏆</span>
                <span className="font-extrabold text-gray-900 leading-tight" data-id="element-209">
                  MEGAPACK ÉLITE
                </span>
              </div>
              <div className="flex flex-wrap gap-2 mb-2" data-id="element-210">
                <span className="inline-flex items-center gap-1 bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-211">
                  <Star className="w-3 h-3 fill-yellow-900" data-id="element-212" /> MÁS ELEGIDO
                </span>
                <span className="inline-flex items-center bg-yellow-100 text-yellow-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-213">
                  AHORRÁS $10.000
                </span>
              </div>
              <p className="text-sm text-gray-500" data-id="element-214">
                12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-215">
              <span className="block text-sm text-gray-400 line-through" data-id="element-216">
                $49.990
              </span>
              <span className="text-2xl font-extrabold text-yellow-600" data-id="element-217">
                $27.990
              </span>
            </div>
          </button>

          {/* CTA */}
          <button onClick={goToCheckout} className="w-full py-5 rounded-2xl font-extrabold text-lg text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 transition-all transform hover:-translate-y-0.5 shadow-lg flex items-center justify-center gap-2" data-id="element-218">
            {selectedPlan === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'SÍ, QUIERO EL PACK PROFESIONAL →'}
          </button>

          <p className="text-center text-sm text-gray-400 italic mt-5" data-id="element-219">
            La opción más elegida por profesores de gimnasia artística
            argentinos
          </p>
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 gap-4 mt-8 text-sm text-gray-500" data-id="element-220">
          <div className="flex items-center gap-2" data-id="element-221">
            <Lock className="w-5 h-5 text-gray-400" data-id="element-222" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-223">
            <Zap className="w-5 h-5 text-yellow-500" data-id="element-224" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2" data-id="element-225">
            <Shield className="w-5 h-5 text-emerald-500" data-id="element-226" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-227">
            <CreditCard className="w-5 h-5 text-gray-400" data-id="element-228" /> Tarjeta ·
            Transferencia · MP
          </div>
        </div>
      </div>
    </section>;
}